import React, { useState } from 'react';
import { COLORS } from '../../../styles/tokens';
import { fieldLabelStyle } from './IconField';
import { calcTons, densityFor } from '../../../utils/quantityCalc';
import { formatNo } from '../../../utils/truckCatalog';

// Enkel mengdekalkulator: areal × tykkelse × tetthet gir tonn. «Bruk» fyller mengdefeltet.
export default function QuantityCalculator({ massType, onUse }) {
  const [open, setOpen] = useState(false);
  const [area, setArea] = useState('');
  const [thickness, setThickness] = useState('');
  const [density, setDensity] = useState('');

  const defaultDensity = densityFor(massType);
  const tons = calcTons({ areaM2: area, thicknessCm: thickness, density: density === '' ? defaultDensity : density });

  function use() {
    onUse(String(tons));
    setOpen(false);
  }

  return (
    <div>
      <button type="button" aria-expanded={open} onClick={() => setOpen(o => !o)} style={styles.toggle}>
        Regn ut mengde
      </button>
      {open && (
        <div style={styles.card}>
          <Field id="qc-area" label="Areal (m²)" value={area} onChange={setArea} />
          <Field id="qc-thick" label="Tykkelse (cm)" value={thickness} onChange={setThickness} />
          <Field id="qc-dens" label="Tetthet (t/m³)" value={density} onChange={setDensity} placeholder={formatNo(defaultDensity)} />
          {tons != null && (
            <button type="button" onClick={use} style={styles.use}>Bruk {formatNo(tons)} tonn</button>
          )}
        </div>
      )}
    </div>
  );
}

function Field({ id, label, value, onChange, placeholder }) {
  return (
    <div style={{ marginBottom: 8 }}>
      <label htmlFor={id} style={{ ...fieldLabelStyle, margin: '0 0 4px' }}>{label}</label>
      <input
        id={id} inputMode="decimal" value={value} placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        style={styles.input}
      />
    </div>
  );
}

const styles = {
  toggle: { background: 'none', border: 'none', padding: '6px 0', fontSize: 13.5, fontWeight: 700, color: COLORS.brandPanel, cursor: 'pointer', textDecoration: 'underline' },
  card:   { marginTop: 6, padding: 12, borderRadius: 12, border: `1px solid ${COLORS.border}`, background: COLORS.white },
  input:  { width: '100%', boxSizing: 'border-box', height: 44, padding: '0 12px', borderRadius: 12, border: `1px solid ${COLORS.border}`, fontSize: 15, fontFamily: 'inherit', background: COLORS.white, color: COLORS.textDark },
  use:    { marginTop: 4, height: 44, width: '100%', borderRadius: 12, border: 'none', background: COLORS.brandPanel, color: '#fff', fontSize: 14.5, fontWeight: 700, cursor: 'pointer' },
};
